import concat from 'lodash/concat'
import reduce from 'lodash/reduce'

const flattenDeepByIteratee = (
  input: Array<any>,
  iteratee: (item: any) => Array<any>
) => {
  return reduce(
    input,
    (acc, item) => {
      const items = iteratee(item)
      return concat(acc, item, items?.length ? items : [])
    },
    []
  )
}

export default flattenDeepByIteratee
